import mutations from '@/store/modules/alertV2/configure/configure.mutations';
import actions from '@/store/modules/alertV2/configure/configure.actions';
import getters from '@/store/modules/alertV2/configure/configure.getters';
import {
  InitOperationsOptions, AlertCapabilities, MeasurementUnits, Operations, AggTypes, AlertActions
} from '@/store/modules/alertV2/configure/config-constant';
import {
  KeyLabel} from './config';
import { Service } from '@/utils/types/global';

export interface State {
  rules: Array<any>;
  totalRules: Number;
  searchTotalRules: Number;
  showAddConfigureAlert: boolean;
  showEditConfigureAlert: boolean;
  showTotalNotificationChannelsTagged:boolean;
  totalNotificationChannelIdsTagged : {}[],
  currentEditConfigureAlert : {},
  refreshAlertRules: boolean;
  notificationsChannels: {}[];
  initOperationsOptions: Array<any>;
  metricsMap: {}[];
  agregationMap: {}[];
  currentCapability: KeyLabel;
  currentSubType: String;
  alertCapabilities: KeyLabel[];
  alertApplication: Service[];
  currentApplication: Service;
  isCreateAlertPopupActive: boolean;
  measurementUnits: {};
  opOptions: object;
  aggTypes: Object;
  alertActions: Object;
  isSearchedAlarmQuery: boolean;
  isErrorCodeEnabled: boolean;
  isStatusTypeEnabled: boolean;
  endpoints: {}[];
  instances: {}[];
  alertApplicationCount: Number;
  endpointCount: Number;
  instanceCount: Number;
  serviceCurrentPage: Number;
  alertApplicationsWithWritePermission: Service[];
  alertApplicationsWithWritePermissionCount: Number;
}

export const initialState: State = {
  rules: [],
  totalRules: 0,
  searchTotalRules: 0,
  currentCapability: { key: '', label: '' },
  currentSubType: '',
  alertCapabilities: AlertCapabilities,
  alertApplication: [],
  currentApplication: { key: '', label: '', permissions: [] },
  showAddConfigureAlert: false,
  showEditConfigureAlert: false,
  showTotalNotificationChannelsTagged:false,
  totalNotificationChannelIdsTagged : [],
  currentEditConfigureAlert:{},
  refreshAlertRules: false,
  notificationsChannels: [],
  initOperationsOptions: InitOperationsOptions,
  metricsMap: [],
  agregationMap: [],
  isCreateAlertPopupActive: false,
  measurementUnits: MeasurementUnits,
  opOptions: Operations,
  aggTypes: AggTypes,
  alertActions: AlertActions,
  isSearchedAlarmQuery: false,
  isErrorCodeEnabled: false,
  isStatusTypeEnabled: false,
  endpoints:[],
  instances: [],
  alertApplicationCount: 0,
  endpointCount: 0,
  instanceCount: 0,
  serviceCurrentPage: 1,
  alertApplicationsWithWritePermission: [],
  alertApplicationsWithWritePermissionCount: 0,
};
 
export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};